var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z",
    fill: "#97ADB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2058 10.6942C18.5663 9.57 16.8116 9 14.991 9C13.3526 9 11.7555 9.4875 10.2439 10.443C8.7195 11.4086 7.22512 13.1625 6 15C6.99075 16.65 8.346 18.3465 9.7575 19.3193C11.3767 20.4345 13.1374 21 14.991 21C16.8285 21 18.5854 20.4349 20.2148 19.3204C21.6491 18.3375 23.0141 16.6433 24 15C23.0107 13.3714 21.6413 11.679 20.2058 10.6942ZM15 18.6C14.288 18.6 13.592 18.3889 12.9999 17.9933C12.4079 17.5977 11.9465 17.0355 11.674 16.3777C11.4016 15.7198 11.3303 14.996 11.4692 14.2977C11.6081 13.5993 11.9509 12.9579 12.4544 12.4544C12.9579 11.9509 13.5993 11.6081 14.2977 11.4692C14.996 11.3303 15.7198 11.4016 16.3777 11.674C17.0355 11.9465 17.5977 12.4079 17.9933 12.9999C18.3889 13.592 18.6 14.288 18.6 15C18.5989 15.9544 18.2193 16.8695 17.5444 17.5444C16.8695 18.2193 15.9544 18.5989 15 18.6Z",
    fill: "#97ADB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4f267518b1679de5688a6260d30af1a9.svg";
export { ForwardRef as ReactComponent };